/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React, { useState } from "react";
import { htmlToPlainText, sanitizeHtml } from "../../../utils/sanitize";
import { useAssetsSrc } from "../../../hooks/useAssetsSrc";
import Icon from "../../ui/Icon";
import styled from "styled-components";
import Text from "../../ui/Text";
import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalImage, ModalTitle } from "../../ui/Modal";
import BookingStepItem from "../steps/BookingStepItem";
import Flex from "../../ui/Flex";

const CardWrapper = styled((props) => <BookingStepItem {...props} />)`
  width: 100%;
  padding: 0.5rem;
  break-inside: avoid;
  background: #fff;
  border-radius: 1rem;
  gap: 0.5rem;
  min-height: 410px;
`;

const CardImageWrapper = styled(Flex)`
  position: relative;
  width: 100%;
  height: 228px;
  border-radius: 0.5rem;
  flex-shrink: 0;
  overflow: hidden;
  background-color: rgba(${({ theme }) => theme.colors.border.rgb}, 0.5);
`;

const CardIcon = styled.img`
  width: 120px;
  height: 120px;
  object-fit: contain;
`;

const CardImage = styled.img`
  width: 100%;
  height: 100%;
  max-height: 500px;
  object-fit: cover;
`;

const ProductsCategoryItem = ({ category, handleCategorySelect }) => {
  const categoryPicture = useAssetsSrc(category.picture_path) || "";
  const [isModalOpen, setIsModalOpen] = useState(false);

  return <>
    <CardWrapper onClick={() => handleCategorySelect(category)}>
      <CardImageWrapper $justify="center" $align="center">
        {category.picture ?
          category?.picture.endsWith('.svg')
            ? <CardIcon src={categoryPicture} alt={category.name} />
            : <CardImage src={categoryPicture} alt={category.name} loading="lazy" decoding="async" />
          : <Icon.Products size={'90px'} strokeWidth={3}/>
        }
      </CardImageWrapper>
      <Flex $direction="column" $gap="0.5rem" $padding="0.5rem">
        <Flex $justify="space-between" $gap="0.6rem">
          <Text lineClamp={2} size="large" color="dark" weight="bold" children={category.name} />
          <Flex $gap="0.3rem" $align="baseline">
            <Text style={{wordBreak: "normal"}} children="Items" />
            <Text color="dark" weight="bold" size="large" style={{wordBreak: "normal"}} children={category.productIds.length} />
          </Flex>
        </Flex>
        {category.description && (
          <Text size="small" onReadMoreClick={() => setIsModalOpen(true)} lineClamp={3}>
            {htmlToPlainText(category.description)}
          </Text>
        )}
      </Flex>
    </CardWrapper>

    <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
      <ModalContent>
        {category.picture_path && !category.picture.endsWith('.svg')  ? (
          <>
            <ModalCloseButton />
            <ModalImage src={categoryPicture} alt={category.name} />
          </>
        ) : (
          <ModalHeader>
            <ModalTitle>{category.name}</ModalTitle>
          </ModalHeader>
        )}
        <ModalBody>
          {category.picture && !category.picture.endsWith('.svg')  && <ModalTitle>{category.name}</ModalTitle>}
          <Text dangerouslySetInnerHTML={{ __html: sanitizeHtml(category.description) }} />
        </ModalBody>
      </ModalContent>
    </Modal>
  </>
}

export default ProductsCategoryItem;